export const INVITE_NEW_DEVELOPER_OPTION_KEY = "invite-new-developer";
export const INVITE_NEW_DEVELOPER_OPTION_LABEL = "Invite new developer";
export const DEFAULT_PROJECT_INVITATION_ROLE = "Developer";
export const DEFAULT_ORGANISATION_USER_ROLE = "Owner";
